import { translate } from '@/domains/core/localization/translate';
export const {
  countryFr,
  countryBe,
  countryDe,
  countryIt,
  countryUk,
  countryEs
} = translate({
  "countryFr": "France",
  "countryBe": "Belgium",
  "countryDe": "Germany",
  "countryIt": "Italy",
  "countryUk": "United Kingdom",
  "countryEs": "Spain"
});
export const fullCountryName: any = {
  DE: countryDe,
  ES: countryEs,
  GB: countryUk,
  IT: countryIt,
  FR: countryFr,
  BE: countryBe
};